import { TEMP_IMAGE_URL } from "~/shared/ui/EmptyImagePlaceholder";
import type { Camera } from "./types";

/** 분석 대상 카메라인지 판별 (analysisNumber가 있고 "N" prefix가 아닌 경우) */
export function isCameraAnalyzed(analysisNumber: string | null): boolean {
  return analysisNumber != null && !analysisNumber.startsWith("N");
}

/**
 * 카메라에 실제 사용 가능한 스냅샷이 있는지 판정.
 *
 * 설계 의도 (PO QA 8차 bh, duri 컨펌 2026-06-05):
 * - 판정 기준은 오직 "진짜 preview 이미지가 있는가" 다. preview 가 truthy 이고 TEMP placeholder 가 아니면 진짜 스냅샷.
 * - mappingType 은 판정에 쓰지 않는다. "add"(수동 추가) 는 단지 "원본 카메라 목록에 없던 카메라"라는 뜻일 뿐,
 *   스냅샷 유무와 직교한다. add 카메라도 이미지를 업로드하면(또는 버전 승계로) 진짜 스냅샷을 가질 수 있다
 *   (BE partial_update 는 preview 만 바꾸고 add 상태를 유지함).
 *
 * 재발 히스토리 (4~5차):
 * - 옛 "빠른 추가" 흐름이 placeholder(temp_image.png) 를 S3 에 올려 가짜 스냅샷을 박았고,
 *   S3 가 파일명을 랜덤화(image_storage_path)해서 가짜와 진짜가 데이터상 구분 불가능해짐.
 * - 5차는 구분이 안 되니 "add 는 전부 차단"으로 퉁쳤으나, 그게 진짜 스냅샷을 가진 add/버전 카메라까지
 *   오살(=8차 bh)했다.
 * - 근본 fix: (1) placeholder 업로드 제거(aca3fdc, 5/20) 로 신규 가짜는 더 안 생기고 preview=null 로 자연 차단,
 *   (2) 옛 가짜-temp preview 는 BE 일회성 청소로 null 처리. 따라서 여기서 add 차단은 불필요·유해 → 제거.
 */
export function hasRealSnapshot(camera: Pick<Camera, "previewImageUrl">): boolean {
  if (!camera.previewImageUrl) return false;
  if (camera.previewImageUrl === TEMP_IMAGE_URL) return false;
  return true;
}
